import { Component } from '@angular/core'
import { SubdomainLinkTypes } from '@app/shared/directives/subdomain-link/subdomain-link.directive'

@Component({
  selector: 'registration-simple-header',
  templateUrl: './registration-simple-header.component.html',
  styleUrls: ['./registration-simple-header.component.scss'],
  standalone: false,
})
export class RegistrationSimpleHeaderComponent {
  subdomainLinksTypes = SubdomainLinkTypes
}
